import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class SupplyTypeService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/supply-type';

  getUrl(): string {
    return this.url;
  }

  getSupplyAll(param?): Observable<any[]> {
    const url = `${this.getUrl()}/find-all-tree?_allow_anonymous=true`;
    let params:any = {};
    if(param){
      params = param;
    }
    params.page = 0;
    params.size = 10000;
    return this.http.get<any>(url,{params:params}).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }

  getSupplyAllByIds(ids,param?): Observable<any[]> {
    const url = `${this.getUrl()}/find-all-tree/`+ids+`/?_allow_anonymous=true`;
    let params:any = {};
    if(param){
      params = param;
    }
    params.page = 0;
    params.size = 10000;
    return this.http.get<any>(url,{params:params}).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }
  findOneByCode(code): Observable<any[]> {
    const url = `${this.getUrl()}/findOneByCode/`+code;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`findOneByCode`)),
      catchError(this.handleError<any>(`findOneByCode`))
    );
  }

  // getSupplyAllSize(param?): Observable<any> {
  //   const url = `${this.getUrl()}/find-all-tree`;
  //   let params = {};
  //   if(param){
  //     params = param;
  //   }
  //   return this.http.get<any>(url,{headers: httpOptions.headers,params:params,observe: 'response'}).pipe(
  //     tap(_ => this.log(`getAll`)),
  //     catchError(this.handleError<any>(`getAll`))
  //   );
  // }
}
